/* Lane Linen — "Buy more, save more" volume-tier selector.
   Mirrors the Shopify Function's tiers (2 = 25% off, 3+ = 30% off), which pool
   any colour/size within a sheet-set family.
   - 1 set: the theme's Add to bag works untouched.
   - 2 / 3 sets: a "build your bundle" panel lists one row per set. Set 1 is the
     colour + size picked above; every other set gets its own colour + size
     dropdown (defaulting to a copy of set 1) so shoppers can see the sets don't
     have to match. Add to bag is intercepted and each set is added as a line.
   The tier + extra-set picks survive the page reload that happens when a
   different colour (a separate product) is chosen for set 1.
   The actual discount is applied automatically by the Function at checkout. */
(function () {
  "use strict";

  /* i18n: window.LL_T (snippets/ll-js-i18n.liquid) maps English UI text to the
     current language; English is the fallback. */
  var LLT = window.LL_T || {};
  function llT(s, n) { var t = LLT[s] || s; return n != null ? t.replace("{n}", n) : t; }
  if (window.__llvInit) return;
  window.__llvInit = true;

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }
  function isWhite(hex) {
    var h = String(hex || "").trim().toLowerCase().replace(/\s/g, "");
    return h === "#ffffff" || h === "#fff" || h === "";
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || "null");
      sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  /* close any open dropdown on outside click / Escape */
  function closeMenus(except) {
    document.querySelectorAll("[data-llv-dd]").forEach(function (dd) {
      if (dd === except) return;
      dd.querySelector("[data-llv-dd-menu]").hidden = true;
      dd.querySelector("[data-llv-dd-btn]").setAttribute("aria-expanded", "false");
    });
  }
  document.addEventListener("click", function (e) {
    var dd = e.target.closest ? e.target.closest("[data-llv-dd]") : null;
    closeMenus(dd);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenus(null); });

  /* ---------- per-root controller ---------- */
  function initVolume(root) {
    if (root.dataset.llvReady) return;
    var dataEl = root.querySelector("[data-llv-colors]");
    if (!dataEl) return;
    var colors;
    try { colors = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.llvReady = "1";

    // variant id -> { ci, si } lookup across every colour
    var byVariant = {};
    colors.forEach(function (c, ci) {
      c.variants.forEach(function (v, si) { byVariant[v.id] = { ci: ci, si: si }; });
    });

    var info = root.closest("product-info") || document;
    var tiers = Array.prototype.slice.call(root.querySelectorAll("[data-llv-tier]"));
    var build = root.querySelector("[data-llv-build]");
    var setsList = root.querySelector("[data-llv-sets]");
    var storeKey = "llv:" + colors.map(function (c) { return c.pid; }).sort().join(",").slice(0, 200);

    var qty = 1;
    var extras = []; // [{ ci, si, touched }] for sets 2..n

    function currentVariantId() {
      var input = info.querySelector('form[data-type="add-to-cart-form"] [name="id"]')
        || info.querySelector('[name="id"]');
      var id = input && input.value;
      if (id && byVariant[id]) return Number(id);
      return Number(root.dataset.defaultVariant);
    }
    function mainPick() { return byVariant[currentVariantId()] || null; }
    // Without colour data for this product, behave like the old quantity-only tiers.
    function canBuild() { return !!mainPick(); }

    function variantAt(p) { return p ? colors[p.ci].variants[p.si] : null; }
    function sizeIndex(ci, size) {
      var vs = colors[ci].variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].size === size) return i;
      return -1;
    }
    function firstAvailable(ci) {
      var vs = colors[ci].variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].available) return i;
      return 0;
    }

    function syncExtras() {
      var m = mainPick();
      while (extras.length < qty - 1) extras.push({ ci: m ? m.ci : 0, si: m ? m.si : 0, touched: false });
      extras.length = Math.max(0, qty - 1);
      // Untouched sets keep copying set 1 until the shopper changes them.
      extras.forEach(function (x) { if (!x.touched && m) { x.ci = m.ci; x.si = m.si; } });
    }

    function persist() {
      store(storeKey, {
        qty: qty,
        extras: extras.map(function (x) { return x.touched ? variantAt(x).id : null; })
      });
    }
    function restore() {
      var saved = store(storeKey);
      if (!saved || !saved.qty || saved.qty < 2 || !canBuild()) return;
      qty = saved.qty;
      syncExtras();
      (saved.extras || []).forEach(function (vid, i) {
        var p = vid && byVariant[vid];
        if (p && extras[i]) { extras[i].ci = p.ci; extras[i].si = p.si; extras[i].touched = true; }
      });
    }

    /* ---------- swatches + dropdowns ---------- */
    function paintSwatch(node, c) {
      if (isWhite(c.hex) && c.img) { node.style.backgroundColor = "#fff"; node.style.backgroundImage = "url('" + c.img + "')"; }
      else { node.style.backgroundColor = c.hex || "#e6e2d6"; node.style.backgroundImage = ""; }
    }

    function dropdown(kind, buttonContent, options) {
      var dd = el("div", "llv__dd llv__dd--" + kind);
      dd.setAttribute("data-llv-dd", "");
      var btn = el("button", "llv__dd-btn");
      btn.type = "button";
      btn.setAttribute("data-llv-dd-btn", "");
      btn.setAttribute("aria-haspopup", "listbox");
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-label", llT(kind === "color" ? "Choose color" : "Choose size"));
      buttonContent(btn);
      btn.insertAdjacentHTML("beforeend", CHEVRON);
      var menu = el("div", "llv__dd-menu");
      menu.setAttribute("data-llv-dd-menu", "");
      menu.setAttribute("role", "listbox");
      menu.hidden = true;
      options.forEach(function (o) {
        var opt = el("button", "llv__dd-opt" + (o.active ? " is-active" : "") + (o.disabled ? " is-disabled" : ""));
        opt.type = "button";
        opt.setAttribute("role", "option");
        opt.setAttribute("aria-selected", o.active ? "true" : "false");
        if (o.swatch) { var sw = el("span", "llv__swatch"); paintSwatch(sw, o.swatch); opt.appendChild(sw); }
        opt.appendChild(document.createTextNode(o.label));
        if (o.disabled) opt.disabled = true;
        else opt.addEventListener("click", function () { closeMenus(null); o.pick(); });
        menu.appendChild(opt);
      });
      btn.addEventListener("click", function () {
        var open = !menu.hidden;
        closeMenus(null);
        if (!open) {
          menu.hidden = false;
          btn.setAttribute("aria-expanded", "true");
          var act = menu.querySelector(".is-active");
          if (act) menu.scrollTop = act.offsetTop - 6;
        }
      });
      dd.appendChild(btn);
      dd.appendChild(menu);
      return dd;
    }

    function renderSets() {
      if (!build) return;
      var multi = qty > 1 && canBuild();
      build.hidden = !multi;
      info.classList.toggle("llv-multi", multi);
      if (!multi) { setsList.innerHTML = ""; return; }

      setsList.innerHTML = "";
      var m = mainPick();
      var mc = colors[m.ci], mv = variantAt(m);

      // Set 1 — mirrors the selection above
      var first = el("li", "llv__set llv__set--main");
      first.appendChild(el("span", "llv__set-num", llT("Set {n}", 1)));
      var firstBody = el("span", "llv__set-main");
      var sw = el("span", "llv__swatch"); paintSwatch(sw, mc);
      firstBody.appendChild(sw);
      firstBody.appendChild(el("span", "llv__set-label", mc.name + " · " + mv.size));
      first.appendChild(firstBody);
      first.appendChild(el("span", "llv__set-tag", llT("Selected above")));
      setsList.appendChild(first);

      extras.forEach(function (x, i) {
        var c = colors[x.ci], v = variantAt(x);
        var li = el("li", "llv__set");
        li.appendChild(el("span", "llv__set-num", llT("Set {n}", i + 2)));
        var pickers = el("span", "llv__set-pickers");

        pickers.appendChild(dropdown("color", function (btn) {
          var s = el("span", "llv__swatch"); paintSwatch(s, c);
          btn.appendChild(s);
          btn.appendChild(el("span", "llv__dd-text", c.name));
        }, colors.map(function (cc, idx) {
          var anyAvail = cc.variants.some(function (vv) { return vv.available; });
          return {
            label: cc.name + (anyAvail ? "" : " — sold out"), swatch: cc, active: idx === x.ci, disabled: !anyAvail,
            pick: function () {
              // keep the same size if the new colour has it in stock
              var keep = sizeIndex(idx, v.size);
              x.ci = idx;
              x.si = keep > -1 && cc.variants[keep].available ? keep : firstAvailable(idx);
              x.touched = true;
              changed();
            }
          };
        })));

        pickers.appendChild(dropdown("size", function (btn) {
          btn.appendChild(el("span", "llv__dd-text", v.size));
        }, c.variants.map(function (vv, idx) {
          return {
            label: vv.size + (vv.available ? "" : " — sold out"), active: idx === x.si, disabled: !vv.available,
            pick: function () { x.si = idx; x.touched = true; changed(); }
          };
        })));

        li.appendChild(pickers);
        if (!v.available) li.appendChild(el("span", "llv__set-warn", llT("Sold out — pick another")));
        setsList.appendChild(li);
      });
    }

    /* ---------- prices ---------- */
    function lineItems() {
      var m = mainPick();
      var ids = [currentVariantId()];
      if (qty > 1 && m) extras.forEach(function (x) { ids.push(variantAt(x).id); });
      return ids;
    }
    function priceOf(id) { var p = byVariant[id]; return p ? variantAt(p).price : 0; }

    function renderPrices() {
      var unit = priceOf(currentVariantId());
      tiers.forEach(function (t) {
        var tq = parseInt(t.dataset.qty, 10) || 1;
        var pct = parseInt(t.dataset.pct, 10) || 0;
        // The active tier totals the actual sets chosen (colours can differ in price).
        var gross = (tq === qty && qty > 1 && canBuild())
          ? lineItems().reduce(function (sum, id) { return sum + priceOf(id); }, 0)
          : unit * tq;
        var net = Math.round(gross * (100 - pct) / 100);
        var priceEl = t.querySelector("[data-llv-price]");
        if (priceEl) priceEl.textContent = money(net);
        var wasEl = t.querySelector("[data-llv-was]");
        if (wasEl) wasEl.innerHTML = pct ? "<s>" + money(gross) + "</s> · " + money(net / tq) + llT("/set") : "";
      });
    }

    /* ---------- Add to bag ---------- */
    function submitButton() { return info.querySelector('product-form [type="submit"]'); }
    function setButtonLabel() {
      var btn = submitButton();
      if (!btn || btn.disabled) return;
      var span = btn.querySelector("span");
      if (!span) return;
      if (!btn.dataset.llvLabel) btn.dataset.llvLabel = span.textContent.trim();
      span.textContent = qty > 1 && canBuild() ? llT("Add {n} sets to bag", qty) : btn.dataset.llvLabel;
    }

    // Theme quantity stays 1 while building a bundle (each set is its own line).
    function setThemeQuantity(n) {
      var q = info.querySelector(".quantity__input") || info.querySelector('[name="quantity"]');
      if (!q) return;
      q.value = n;
      q.dispatchEvent(new Event("change", { bubbles: true }));
      q.dispatchEvent(new Event("input", { bubbles: true }));
    }

    var productForm = info.querySelector("product-form");
    if (productForm) {
      // Capture on the <product-form> wrapper so this runs before Dawn's own
      // submit handler on the inner <form>.
      productForm.addEventListener("submit", function (e) {
        if (qty < 2 || !canBuild()) return;
        e.preventDefault();
        e.stopPropagation();
        addBundle();
      }, true);
    }

    function addBundle() {
      var btn = submitButton();
      if (!btn || btn.getAttribute("aria-disabled") === "true") return;
      var counts = {};
      var order = [];
      var bad = false;
      lineItems().forEach(function (id) {
        var p = byVariant[id];
        if (!p || !variantAt(p).available) bad = true;
        if (!counts[id]) { counts[id] = 0; order.push(id); }
        counts[id]++;
      });
      if (bad) { root.querySelector(".llv__set-warn") && root.querySelector(".llv__set-warn").scrollIntoView({ block: "center", behavior: "smooth" }); return; }

      var cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      var body = { items: order.map(function (id) { return { id: id, quantity: counts[id] }; }) };
      var drawer = cart && cart.tagName === "CART-DRAWER" && typeof cart.getSectionsToRender === "function";
      if (drawer) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      btn.setAttribute("aria-disabled", "true");
      btn.classList.add("loading");
      var spinner = btn.querySelector(".loading__spinner");
      if (spinner) spinner.classList.remove("hidden");
      function done() {
        btn.removeAttribute("aria-disabled");
        btn.classList.remove("loading");
        if (spinner) spinner.classList.add("hidden");
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          done();
          if (res.status) {
            var err = info.querySelector(".product-form__error-message");
            var wrap = info.querySelector(".product-form__error-message-wrapper");
            if (err && wrap) { err.textContent = res.description || res.message; wrap.hidden = false; }
            return;
          }
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: order[0], cartData: res });
          }
          if (drawer) {
            var d = cart.querySelector(".drawer__inner");
            if (d && d.classList.contains("is-empty")) d.classList.remove("is-empty");
            cart.renderContents(res);
          } else {
            window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
          }
        })
        .catch(function () { done(); });
    }

    /* ---------- wiring ---------- */
    function changed() {
      syncExtras();
      renderSets();
      renderPrices();
      setButtonLabel();
      persist();
    }

    function selectTier(n) {
      qty = n;
      tiers.forEach(function (x) {
        var on = (parseInt(x.dataset.qty, 10) || 1) === n;
        x.classList.toggle("is-active", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      setThemeQuantity(canBuild() ? 1 : n);
      changed();
    }

    tiers.forEach(function (t) {
      t.addEventListener("click", function () { selectTier(parseInt(t.dataset.qty, 10) || 1); });
    });

    // Size change for set 1: Dawn swaps the variant id, then re-renders the
    // button text — re-apply ours after it settles.
    info.addEventListener("change", function () { setTimeout(changed, 0); });
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(changed, 0); });
    }

    restore();
    selectTier(qty);
  }

  function initAll() { document.querySelectorAll("[data-llv-root]").forEach(initVolume); }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
